// Generated by CoffeeScript 1.6.3
(function() {
  rjm.model.LSColumn = Backbone.RelationalModel.extend({
    initialize: function(options) {
      if (!options || !options.sid) {
        throw "InvalidConstructorArgs - LSColumn";
      }
      _.bindAll(this, "toJSON", "isDateTime");
      if (rjm.app.localStructure[options.sid]) {
        return this.set({
          sid: parseInt(options.sid, 10),
          name: rjm.app.localStructure[options.sid].name,
          datatype: rjm.app.localStructure[options.sid].datatype,
          derivativeType: rjm.app.localStructure[options.sid].derivative
        });
      }
    },
    isDateTime: function() {
      return this.get("datatype") === "DATETIME";
    },
    toJSON: function() {
      var r, x;
      r = Backbone.RelationalModel.prototype.toJSON.call(this);
      x = {};
      x.sid = r.sid;
      return x;
    },
    equal: function(lsColumn) {
      if (lsColumn == null) {
        return false;
      }
      if (this.get("sid") !== lsColumn.get("sid")) {
        return false;
      }
      return true;
    }
  });

  rjm.model.LSColumnList = Backbone.Collection.extend({
    model: rjm.model.LSColumn,
    comparator: function(lsColumn) {
      return lsColumn.get("name").toLowerCase();
    }
  });

}).call(this);
